import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import { useHandleError } from "../hooks/useHandleError";
import axios from "axios";
import { BASE_URL } from "../api";
import { getApiHeaders } from "../utils/helpers";
import MessageToster from "../component/MessageToster";
import Loader from "../component/Loader";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import { LEVERAGE_OPTIONS } from "../utils/constant";
import { exportToExcel } from "../utils/exportData";
import ExportButton from "../component/ExportButton";
import MobileFilter from "../component/MobileFilter";
// import Ade from "../component/Ade";

export default function LeverageHistory() {
  const handleError = useHandleError();
  const mid = sessionStorage.getItem("mid");
  const today = new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  const weekAgoDate = oneWeekAgo.toISOString().split("T")[0];

  const [loading, setLoading] = useState(false);
  const [leverageData, setLeverageData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  // const [accounts, setAccounts] = useState([]);
  const [modalInput, setModalInput] = useState({
    accountType: "",
    account: "",
    leverage: ""
  });
  const [modalErrors, setModalErrors] = useState({
    accountType: "",
    account: "",
    leverage: ""
  });
  const [filters, setFilters] = useState({
    accountType: "demo",
    account: "",
    fromDate: weekAgoDate,
    toDate: today
  });

  const [filterAccounts, setFilterAccounts] = useState([]);
  const [modalAccounts, setModalAccounts] = useState([]);

  const [accountsCache, setAccountsCache] = useState({
    live: null,
    demo: null
  });


  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));

    if (name === "accountType") {
      setFilters(prev => ({ ...prev, accountType: value, account: "" }));
      setFilterAccounts([]);
      const list = await getAllAccounts(value, 'filter');
      const firstAcc = list && list.length > 0 ? list[0] : "";
      setFilters(prev => ({ ...prev, accountType: value, account: firstAcc }));
      if (firstAcc) {
        getLeverageHistory({
          ...filters,
          accountType: value,
          account: firstAcc
        });
      }
    }

  };

  const handleModalChange = async (e) => {
    const { name, value } = e.target;

    setModalInput((prev) => ({ ...prev, [name]: value }));
    setModalErrors((prev) => ({ ...prev, [name]: "" }));

    if (name === "accountType") {
      setModalInput(prev => ({ ...prev, account: "" }));
      // setAccounts([]);
      setModalAccounts([]);
      await getAllAccounts(value, 'modal');
    }
  };

  const clearFilters = () => {
    setFilters((prev) => ({
      ...prev,
      fromDate: "",
      toDate: ""
    }));
    setSearchTerm("");
    setSearchQuery("");
  };

  const handleReset = () => {

    setModalInput({
      accountType: "",
      account: "",
      leverage: ""
    });

    setModalErrors({
      accountType: "",
      account: "",
      leverage: ""
    });
  };

  const getAllAccounts = async (type, target) => {
    if (!type) return [];

    if (accountsCache[type]) {
      if (target === "filter") setFilterAccounts(accountsCache[type]);
      if (target === "modal") setModalAccounts(accountsCache[type]);
      return accountsCache[type];
    }

    // const inputBody = { mid: Number(mid), mode: "" };

    const url =
      type === "live"
        ? `${BASE_URL}/MT5M/real_accounts_number_list`
        : `${BASE_URL}/MT5M/demo_account_number_list`;

    try {
      setLoading(true);
      const res = await axios.get(url, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        // setAccounts(res.data.data || []);
        const list = res.data.data || [];
        // setAccounts(list);

        setAccountsCache(prev => ({
          ...prev,
          [type]: list
        }));

        if (target === "filter") setFilterAccounts(list);
        if (target === "modal") setModalAccounts(list);
        return list;

      } else {
        MessageToster("error", res.data.message || "Failed to fetch accounts");
        return [];
      }
    } catch (error) {
      handleError(error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const updateLeverage = async () => {
    let errors = {};

    if (!modalInput.accountType) errors.accountType = "Please select account type";
    if (!modalInput.account) errors.account = "Please select account";
    if (!modalInput.leverage) errors.leverage = "Please select leverage";

    setModalErrors(errors);

    // STOP submit if errors exist
    if (Object.keys(errors).length > 0) return;

    // const inputBody = {
    //   mid: Number(mid),
    //   account_number: Number(filters.account_number),
    //   // leverage: Number(leverage)
    // }

    const inputBody = {
      // mid: Number(mid),
      account_number: Number(modalInput.account),
      leverage: modalInput.leverage
    };

    try {
      setLoading(true);

      const res = await axios.put(`${BASE_URL}/MT5M/update_user_account_leverage`, inputBody, { headers: getApiHeaders() });

      if (res.data.code === 200) {
        MessageToster("success", "Leverage Updated Successfully");
        handleReset();

        // Close modal
        const closeBtn = document.querySelector(".bs-example-modal-center .btn-close");
        if (closeBtn) closeBtn.click();

        // Only refresh history if table filter has account selected
        if (filters?.accountType && filters?.account) {
          getLeverageHistory(filters);
        }
      } else {
        MessageToster("error", res.data.message || "Failed to update leverage");
      }

    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  }

  const getLeverageHistory = async (filters) => {

    if (!filters.accountType) {
      return MessageToster("error", "Please select account type");
    }
    if (!filters.account) {
      return MessageToster("error", "Please select account number");
    }

    setLoading(true);
    try {
      // const inputBody = {
      //   mid: 25,
      //   account_number: 90392978,
      //   from_date: "",
      //   to_date: ""
      // }
      const inputBody = {
        // mid: Number(mid),
        account_number: Number(filters.account),
        // from_date: filters.fromDate,
        // to_date: filters.toDate
        from_date: filters.fromDate?.split("-").reverse().join("-"),
        to_date: filters.toDate?.split("-").reverse().join("-")
      }

      const res = await axios.post(`${BASE_URL}/MT5M/mt5_account_leverage_history`, inputBody, { headers: getApiHeaders() });

      if (res.data.code === 200 && Array.isArray(res.data.data)) {
        setSearchQuery(searchTerm);
        setLeverageData(res.data.data);
      } else {
        setLeverageData([]);
        MessageToster("error", res.data.message || "No open trades found");
      }
    }
    catch (error) {
      setLeverageData([]);
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initPage = async () => {
      const list = await getAllAccounts("demo", "filter");
      const firstAcc = list && list.length > 0 ? list[0] : "";
      setFilters(prev => ({
        ...prev,
        accountType: "demo",
        account: firstAcc
      }));
      if (firstAcc) {
        getLeverageHistory({
          accountType: "demo",
          account: firstAcc,
          fromDate: weekAgoDate,
          toDate: today
        });
      }
    };
    initPage();
  }, []);

  useEffect(() => {

  }, [leverageData]);

  const filteredData = leverageData.filter((item) => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      String(item.account_number || "").toLowerCase().includes(query) ||
      String(item.account_type || "").toLowerCase().includes(query) ||
      String(item.old_leverage || "").toLowerCase().includes(query) ||
      String(item.new_leverage || "").toLowerCase().includes(query) ||
      String(item.changed_by || "").toLowerCase().includes(query)
    );
  });

  return (
    <>
      <div id="layout-wrapper">
        {loading &&
          <Loader />
        }
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-0">Leverage History</h2>
                    <div className="change_leverage_btn">
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        data-bs-toggle="modal"
                        data-bs-target=".bs-example-modal-center"
                        onClick={handleReset}
                      >
                        Change Leverage
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            max={filters.toDate || today}
                            value={filters.fromDate}
                            onChange={handleChange}
                            id="example-date-input"
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            min={filters.fromDate || undefined}
                            max={today}
                            value={filters.toDate}
                            onChange={handleChange}
                            id="example-date-input"
                          />
                        </div>
                        <div>
                          <label htmlFor="">Account Type</label>
                          <select
                            className="form-select"
                            name="accountType"
                            value={filters.accountType}
                            onChange={handleChange}
                          >
                            <option value="" disabled hidden>
                              Select Account Type
                            </option>
                            <option value="live">Live</option>
                            <option value="demo">Demo</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Account Number</label>
                          <select
                            className="form-select"
                            name="account"
                            value={filters.account}
                            onChange={handleChange}
                            disabled={!filters.accountType}
                          >
                            <option value="" disabled hidden>
                              {filterAccounts?.length > 0 ? "Select Account No" : "No Account Found"}
                            </option>
                            {filterAccounts?.length > 0 ? (
                              filterAccounts.map((acc) => (
                                <option key={acc} value={acc}>
                                  {acc}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>No accounts available</option>
                            )}
                          </select>
                        </div>

                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>

                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={() => getLeverageHistory(filters)}
                          >
                            Search
                          </button>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                          >
                            Clear
                          </button>
                        </div>
                        <div className="ms-auto">
                          <ExportButton
                            onClick={() => exportToExcel(leverageData, "leverage_history", "leverage_history")}
                          />
                        </div>
                      </div>

                      <MobileFilter
                        title="History"
                        onExport={() => exportToExcel(leverageData, "leverage_history", "leverage_history")}
                      >
                        <div>
                          <label htmlFor="">From</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="fromDate"
                            max={filters.toDate || today}
                            value={filters.fromDate}
                            onChange={handleChange}
                          />
                        </div>
                        <div>
                          <label htmlFor="">To</label>
                          <input
                            className="form-control"
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            name="toDate"
                            min={filters.fromDate || undefined}
                            max={today}
                            value={filters.toDate}
                            onChange={handleChange}
                          />
                        </div>
                        <div>
                          <label htmlFor="">Account Type</label>
                          <select
                            className="form-select"
                            name="accountType"
                            value={filters.accountType}
                            onChange={handleChange}
                          >
                            <option value="" disabled hidden>
                              Select Account Type
                            </option>
                            <option value="live">Live</option>
                            <option value="demo">Demo</option>
                          </select>
                        </div>
                        <div>
                          <label htmlFor="">Account Number</label>
                          <select
                            className="form-select"
                            name="account"
                            value={filters.account}
                            onChange={handleChange}
                            disabled={!filters.accountType}
                          >
                            <option value="" disabled hidden>
                              {filterAccounts?.length > 0 ? "Select Account No" : "No Account Found"}
                            </option>
                            {filterAccounts?.length > 0 ? (
                              filterAccounts.map((acc) => (
                                <option key={acc} value={acc}>
                                  {acc}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>No accounts available</option>
                            )}
                          </select>
                        </div>

                        <div>
                          <label htmlFor="">Search</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                        </div>

                        <div className="d-flex gap-2 mt-2">
                          <button
                            type="button"
                            className="btn btn-primary waves-effect waves-light flex-grow-1"
                            onClick={() => getLeverageHistory(filters)}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Search
                          </button>
                          <button
                            type="button"
                            className="btn btn-light waves-effect waves-light border flex-grow-1"
                            onClick={clearFilters}
                            disabled={!filters.fromDate && !filters.toDate && !searchTerm}
                            data-bs-dismiss="offcanvas"
                            data-bs-target="#filterOffcanvasMobile"
                          >
                            Clear
                          </button>
                        </div>
                      </MobileFilter>
                      <CommonTable
                        columns={[
                          { header: "Account No", accessor: "account_number" },
                          { header: "Date", render: (row) => row.ondate ? formatDateDDMMYYYY(row.ondate) : "-" },
                          { header: "Account Type", accessor: "account_type" },
                          { header: "Old Leverage", accessor: "old_leverage" },
                          { header: "New Leverage", accessor: "new_leverage" },
                          { header: "Changed By", accessor: "changed_by" }
                        ]}
                        data={filteredData}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>{" "}
                {/* end col */}
                <div>
                  {/* modal */}
                  <div
                    className="modal fade bs-example-modal-center"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Change Leverage</h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          />
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Account Type{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  name="accountType"
                                  value={modalInput.accountType}
                                  onChange={handleModalChange}
                                >
                                  {/* <option value="MT5">Select an Option</option> */}
                                  <option value="" disabled hidden>Select Type</option>
                                  <option value="live">Live</option>
                                  <option value="demo">Demo</option>
                                </select>
                                {modalErrors.accountType && (
                                  <p className="text-danger">{modalErrors.accountType}</p>
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Account No{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  // name="select"
                                  name="account"
                                  value={modalInput.account}
                                  onChange={handleModalChange}
                                  disabled={!modalInput.accountType}
                                >
                                  {/* <option value="MT5">Select an Option</option> */}
                                  <option value="" disabled hidden>Select Account No</option>
                                  {modalAccounts.length > 0 ? (
                                    modalAccounts.map((acc) => (
                                      <option key={acc} value={acc}>
                                        {acc}
                                      </option>
                                    )))
                                    : (
                                      <option value="" disabled>No accounts available</option>
                                    )
                                  }
                                </select>
                                {modalErrors.account && (
                                  <p className="text-danger">{modalErrors.account}</p>
                                )}
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Leverage{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className="form-select"
                                  name="leverage"
                                  value={modalInput.leverage}
                                  onChange={handleModalChange}
                                >
                                  <option value="" disabled hidden>Select Leverage</option>
                                  {
                                    LEVERAGE_OPTIONS.map(value => (
                                      <option key={value} value={value}>
                                        1:{value}
                                      </option>
                                    ))
                                  }
                                  {/* <option value="100">1:100</option>
                                  <option value="200">1:200</option>
                                  <option value="300">1:300</option>
                                  <option value="400">1:400</option>
                                  <option value="500">1:500</option> */}
                                </select>
                                {modalErrors.leverage && (
                                  <p className="text-danger">{modalErrors.leverage}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setModalInput({ leverage: "" });
                              setModalErrors({});
                            }}
                          >
                            Reset
                          </button>
                          <button type="button" className="btn btn-primary" onClick={updateLeverage}
                            aria-label="Close">
                            Submit
                          </button>
                        </div>
                      </div>
                      {/* /.modal-content */}
                    </div>
                    {/* /.modal-dialog */}
                  </div>
                  {/* /.modal */}
                </div>
              </div>
              {/* <Ade /> */}

            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
